import { Link } from 'react-router-dom';

const TOOL_LINKS = [
  ['PDF to Word', '/tools/pdf-to-word'],
  ['Word to PDF', '/tools/word-to-pdf'],
  ['PDF to Excel', '/tools/pdf-to-excel'],
  ['Excel to PDF', '/tools/excel-to-pdf'],
  ['Merge PDF', '/tools/merge-pdf'],
  ['Split PDF', '/tools/split-pdf'],
  ['Compress PDF', '/tools/compress-pdf'],
  ['OCR PDF', '/tools/ocr-pdf'],
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-100 bg-white mt-24"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid md:grid-cols-5 gap-8">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Go Convert Documents" className="h-10 w-10 object-contain rounded-lg" />
            <div className="leading-tight">
              <p className="font-display font-extrabold text-lg" style={{ color: 'var(--ink)' }}>Go Convert</p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400 font-semibold -mt-0.5">Documents</p>
            </div>
          </div>
          <p className="text-sm text-slate-500 mt-4 leading-relaxed">
            Free online document converter. Fast, secure, no registration required.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-slate-400 font-semibold">Popular tools</p>
          <ul className="mt-4 space-y-2">
            {TOOL_LINKS.map(([label, href]) => (
              <li key={href}>
                <Link
                  to={href}
                  data-testid={`footer-tool-${href.split('/').pop()}`}
                  className="text-sm text-slate-600 hover:text-blue-600"
                  style={{ transition: 'color .2s' }}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-slate-400 font-semibold">Resources</p>
          <ul className="mt-4 space-y-2">
            <li><Link to="/blog" data-testid="footer-blog" className="text-sm text-slate-600 hover:text-blue-600">Blog</Link></li>
            <li><Link to="/developers" data-testid="footer-developers" className="text-sm text-slate-600 hover:text-blue-600">Developers / API</Link></li>
            <li><Link to="/embed" data-testid="footer-embed" className="text-sm text-slate-600 hover:text-blue-600">Embed widget</Link></li>
            <li><Link to="/partners" data-testid="footer-partners" className="text-sm text-slate-600 hover:text-blue-600">Partners &amp; media kit</Link></li>
            <li><a href="/#how-it-works" className="text-sm text-slate-600 hover:text-blue-600">How it works</a></li>
            <li><a href="/#faq" className="text-sm text-slate-600 hover:text-blue-600">FAQ</a></li>
            <li><Link to="/about" data-testid="footer-about" className="text-sm text-slate-600 hover:text-blue-600">About</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-slate-400 font-semibold">Compare</p>
          <ul className="mt-4 space-y-2">
            <li><Link to="/vs/ilovepdf" data-testid="footer-vs-ilovepdf" className="text-sm text-slate-600 hover:text-blue-600">vs iLovePDF</Link></li>
            <li><Link to="/vs/smallpdf" data-testid="footer-vs-smallpdf" className="text-sm text-slate-600 hover:text-blue-600">vs Smallpdf</Link></li>
            <li><Link to="/vs/pdf24" data-testid="footer-vs-pdf24" className="text-sm text-slate-600 hover:text-blue-600">vs PDF24</Link></li>
            <li><Link to="/vs/sejda" data-testid="footer-vs-sejda" className="text-sm text-slate-600 hover:text-blue-600">vs Sejda</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-slate-400 font-semibold">Company</p>
          <ul className="mt-4 space-y-2">
            <li><Link to="/contact" data-testid="footer-contact" className="text-sm text-slate-600 hover:text-blue-600">Contact</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy" className="text-sm text-slate-600 hover:text-blue-600">Privacy policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="text-sm text-slate-600 hover:text-blue-600">Terms of service</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm">
          <p className="text-slate-500">
            © {new Date().getFullYear()} Go Convert Documents — Convert with power.
          </p>
          <p className="text-slate-500">
            Files auto-delete after 1 hour · No sign-up · No tracking
          </p>
        </div>
      </div>
    </footer>
  );
}
